import { useQuery } from "@tanstack/react-query";

import { getFarmAreaSummary } from "services";

import { GET_FARM_AREA_SUMMARY } from "consts";

import { FarmAreaSummaryResponse } from "models";

export const useGetFarmAreaSummary = ({ farmId }: { farmId: string }) => {
  const { data, isLoading, isSuccess, isFetching } = useQuery<FarmAreaSummaryResponse>({
    queryKey: [GET_FARM_AREA_SUMMARY, farmId],
    queryFn: () => getFarmAreaSummary({ farmId }),
    enabled: !!farmId,
  });

  return {
    areaSummary: isSuccess ? data : null,
    isLoading,
    isFetching,
  };
};
